/* eslint-disable */
export const downloadBlob = data => {
  const downloadUrl = URL.createObjectURL(data);
  window.open(downloadUrl, "_blank");
};
